import { PoinzApiClient } from '../../api';
import { IAllEntitySlugs } from './types/slug';

const apiRoot = `/search/slugs`;

const get = (apiClient: PoinzApiClient) => async (): Promise<IAllEntitySlugs> => {
  const response = await apiClient.get(apiRoot, {});

  return response.body;
};

export default (apiClient: PoinzApiClient) => ({
  get: get(apiClient)
});
